import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDown } from 'lucide-react';

import { cn } from '../../lib/utils';

function Accordion(props: AccordionPrimitive.AccordionSingleProps | AccordionPrimitive.AccordionMultipleProps): JSX.Element {
  return <AccordionPrimitive.Root {...props} />;
}

function AccordionItem({ className, ...props }: AccordionPrimitive.AccordionItemProps): JSX.Element {
  return <AccordionPrimitive.Item className={cn('border-b border-[color:var(--color-border)]', className)} {...props} />;
}

function AccordionTrigger({ className, children, ...props }: AccordionPrimitive.AccordionTriggerProps): JSX.Element {
  return (
    <AccordionPrimitive.Header className="flex">
      <AccordionPrimitive.Trigger
        className={cn(
          'group flex flex-1 items-center justify-between gap-3 py-4 text-left text-sm font-semibold text-[color:var(--color-text)] transition-colors hover:text-[color:var(--color-primary)]',
          className,
        )}
        {...props}
      >
        {children}
        <ChevronDown className="h-4 w-4 shrink-0 transition-transform duration-200 group-data-[state=open]:rotate-180" />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
}

function AccordionContent({ className, children, ...props }: AccordionPrimitive.AccordionContentProps): JSX.Element {
  return (
    <AccordionPrimitive.Content
      className={cn('overflow-hidden text-sm text-[color:var(--color-muted)] data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down', className)}
      {...props}
    >
      <div className="pb-4 pr-3">{children}</div>
    </AccordionPrimitive.Content>
  );
}

export { Accordion, AccordionContent, AccordionItem, AccordionTrigger };
